import React, { useState } from 'react';
import { useAuth } from '../../providers/auth';
import { createNewEntryForApplicationTracker } from '../../data/ApplicationTracker';



const ApplyConfirmation = ({
  jobData,
  setApplyConfirmationSent,
  setApplyConfirmationSentTag,
}: any) => {
  const { user } = useAuth();
  const [actions, setActions] = useState("");

  const handleYesClick = async (action = "yes") => {
    if (!user) {
      console.warn("User not found");
      return;
    }

    setActions(action);

    const applicationData = {
      userId: user.uid,
      jobId: jobData.id,
      jobTitle: jobData.jobName,
      companyName: jobData.companyFullName,
      jobData,
      appliedConfirmation: action,
      ...(action === "yes" && { appliedAt: new Date() }),
    };

    try {
         await createNewEntryForApplicationTracker(applicationData);

      if (action === "yes") {

           setApplyConfirmationSentTag({ jobId: jobData.id, isSent: true });
       }


   
      // Optional: close confirmation after success
      setApplyConfirmationSent(false);

    } catch (error) {
      console.error("Error creating application tracker entry:", error);
    } finally {
      setActions("");
    }
  };

  return (
    <div className="mr-0 w-full flex items-center flex-col justify-center">
      <p className="text-instant-teams-blue-Main text-center text-sm ">
        Did you apply for this job??
      </p>

      <div className="flex mt-[6px] w-[90%] pb-1 justify-between">
        <button
          onClick={() => handleYesClick("yes")}
          disabled={actions === "yes"}
          className="border border-instant-teams-blue-Main text-instant-teams-blue-Main px-5 py-[2px] text-sm rounded-full disabled:opacity-50"
        >
          {actions === "yes" ? "..." : "Yes"}
        </button>

        <button
          onClick={() => handleYesClick("no")}
          className="border border-instant-teams-red-Main text-instant-teams-red-Main px-5 text-sm rounded-full"
        >
          {actions === "no" ? "..." : "No"}
        </button>
      </div>
    </div>
  );
};

export default ApplyConfirmation;